import React, { useCallback, useState } from "react";
import "./Details.css";
import RichTextContent, { CmsText } from "../../../../RichTextContent/RichTextContent";
import { resolveMediaUrl } from "../../../../../utils/mediaUrl";
import { stripRichText } from "../../../../../utils/richText";

function getShareUrl() {
  if (typeof window === "undefined") return "";
  return window.location.href;
}

function openShareWindow(url) {
  window.open(url, "_blank", "noopener,noreferrer,width=600,height=520");
}

const Details = ({ article }) => {
  const imageSrc = resolveMediaUrl(article?.image);
  const avatarSrc = resolveMediaUrl(article?.avatar);
  const [copied, setCopied] = useState(false);

  const handleCopyLink = useCallback(async () => {
    const url = getShareUrl();
    if (!url) return;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement("textarea");
        input.value = url;
        input.setAttribute("readonly", "");
        input.style.position = "absolute";
        input.style.left = "-9999px";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }, []);

  const handleShare = useCallback((network) => {
    const url = encodeURIComponent(getShareUrl());
    const title = encodeURIComponent(article?.title || "Vucali Insights");

    const shareUrls = {
      x: `https://twitter.com/intent/tweet?url=${url}&text=${title}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    };

    const shareUrl = shareUrls[network];
    if (shareUrl) openShareWindow(shareUrl);
  }, [article?.title]);

  return (
    <section className="details">
      <div className="details__container">

        {/* INTRO */}
        {article?.desc ? <RichTextContent content={article.desc} /> : null}

        {/* TITLE */}
        <h3>Introduction</h3>

        <p>
          Mi tincidunt elit, id quisque ligula ac diam, amet. Vel etiam suspendisse
          morbi eleifend faucibus eget vestibulum felis. Dictum quis montes,
          sit sit. Tellus aliquam enim urna, etiam. Mauris posuere vulputate arcu
          amet, vitae nisi, tellus tincidunt.
        </p>

        <p>
          Eget quis mi enim, leo lacinia pharetra, semper. Eget in volutpat mollis
          at volutpat lectus velit, sed auctor. Porttitor fames arcu quis fusce augue
          enim. Quis at habitant diam at.
        </p>

        {/* IMAGE */}
        {imageSrc ? (
          <div className="details__image">
            <img src={imageSrc} alt={stripRichText(article.title)} />
            <span>Image source: Unsplash</span>
          </div>
        ) : null}

        {/* QUOTE */}
        <div className="details__quote">
          <p>
            “In a world older and more complete than ours they move finished and
            complete, gifted with extensions of the senses we have lost or never
            attained, living by voices we shall never hear.”
          </p>
          <span>
            —{" "}
            <CmsText content={article.author} as="span" />,{" "}
            <CmsText content={article.role} as="span" />
          </span>
        </div>

        {/* MORE TEXT */}
        <p>
          Dolor enim eu tortor urna sed duis nulla. Aliquam vestibulum, nulla odio
          nisl vitae. In aliquet pellentesque aenean hac vestibulum turpis mi
          bibendum diam. Tempor integer aliquam in vitae malesuada fringilla.
        </p>

        <h3>Software and tools</h3>

        <p>
          Pharetra morbi libero id aliquam elit massa integer tellus. Quis felis
          aliquam ullamcorper porttitor. Pulvinar ullamcorper sit dictumst ut eget
          a, elementum eu.
        </p>

        <h3>Other resources</h3>

        <ul>
          <li>Lorem ipsum dolor sit amet</li>
          <li>Consectetur adipiscing elit</li>
          <li>Integer nec odio praesent libero</li>
        </ul>

        {/* IMAGE 2 */}
        {imageSrc ? (
          <div className="details__image">
            <img src={imageSrc} alt={stripRichText(article.title)} />
            <span>Image source: Unsplash</span>
          </div>
        ) : null}

        <p>
          Lectus ut massa tristique. Risus odio risus consequat sapien. Lorem
          ipsum dolor sit amet consectetur adipisicing elit.
        </p>

        {/* AUTHOR SECTION */}
        <div className="details__footer">

          <div className="details__author">
            {avatarSrc ? (
              <img src={avatarSrc} alt={stripRichText(article.author)} />
            ) : null}
            <div>
              {article.author ? (
                <CmsText content={article.author} as="h4" />
              ) : null}
              {article.role ? (
                <CmsText content={article.role} as="span" />
              ) : null}
            </div>
          </div>

          <div className="details__share">
            <button
              type="button"
              className="buttonclip"
              onClick={handleCopyLink}
              aria-label="Copy article link"
            >
              {copied ? "Copied!" : "Copy link"}
            </button>
            <button
              type="button"
              className="buttonclip"
              onClick={() => handleShare("x")}
              aria-label="Share on X"
            >
              X
            </button>
            <button
              type="button"
              className="buttonclip"
              onClick={() => handleShare("facebook")}
              aria-label="Share on Facebook"
            >
              f
            </button>
            <button
              type="button"
              className="buttonclip"
              onClick={() => handleShare("linkedin")}
              aria-label="Share on LinkedIn"
            >
              in
            </button>
          </div>

        </div>

      </div>
    </section>
  );
};

export default Details;
